<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600" scrollable>
    <v-card elevation="0">
      <v-toolbar flat class="opposite--text" color="primary">
        <span class="ml-2 text-truncate">{{ profile ? profile.name : "" }}</span>
        <v-spacer></v-spacer>
        <v-btn color="opposite" icon @click="$emit('input', false)">
          <v-icon size="20">mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-container v-if="loading" class="text-center pa-6">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-container>
        <CompetitorStatsSummary v-else-if="profile" :profile="profile" :active-tournaments="activeTournaments"
          :checking-active="false" :results="results" :show-active-banner="false" :show-affiliation-history="false">
        </CompetitorStatsSummary>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text :disabled="!profile" @click="viewFullProfile()">
          {{ $t("message.view_details") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IBJJFService from "@/services/IBJJFService";
import CompetitorStatsSummary from "@/components/displays/CompetitorStatsSummary";

export default {
  name: "CompetitorStatsDialogDisplay",
  components: {
    CompetitorStatsSummary,
  },
  props: {
    value: { type: Boolean, default: false },
    competitorId: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      profile: null,
      activeTournaments: [],
      results: [],
    };
  },
  watch: {
    value(isOpen) {
      if (isOpen) this.loadProfile();
    },
    competitorId() {
      if (this.value) this.loadProfile();
    },
  },
  methods: {
    loadProfile() {
      if (!this.competitorId) return;
      this.loading = true;
      this.profile = null;
      this.activeTournaments = [];
      this.results = [];
      IBJJFService.getCompetitorProfile(this.competitorId)
        .then((data) => {
          this.loading = false;
          this.profile = data.competitor;
          this.activeTournaments = data.activeTournaments || [];
          this.results = data.results || [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    viewFullProfile() {
      if (!this.profile) return;
      this.$emit("input", false);
      this.$router.push({
        name: "ibjjfcompetitorsprofile",
        params: { competitorId: this.profile._id },
      });
    },
  },
};
</script>
